module.exports = __webpack_public_path__ + "img/3C.664444aa.png";